import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip, Chip, Avatar, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import UpdateIcon from '@mui/icons-material/Update';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { deleteObjectApi } from 'api/general';
import { ANNOUNCEMENT } from 'app/utils/constants/customConstant';
import Swal from 'sweetalert2';
import AnnouncementDataTableToolbar from './AnnouncementDataTableToolbar';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import { useSelector } from 'react-redux';
import { getLocaleDateTime, getLocaleDateWithTimeCustomV2, getUserFullName, highlightText, isRoleCheckList } from 'app/utils/appHelpers';
import AddUpdateAnnouncementDialog from 'app/components/Dialog/AddUpdateAnnouncementDialog';
import AnnouncementItemDialog from 'app/components/Dialog/AnnouncementItemDialog';
import config from '../../../../config';

function AnnouncementDataTable({ mainData = [], column, pageTitle }) {

    const { authUser } = useSelector(state => state.auth);

    const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);

    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const [updateInfoDialogStatus, setUpdateInfoDialogStatus] = useState(false);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState();
    const [detailDialogStatus, setDetailDialogStatus] = useState(false);
    const [selectedDetailAnnouncement, setSelectedDetailAnnouncement] = useState();
    const userList = useSelector(state => state.user.data);
    const [highlightQuery, setHighlightQuery] = useState('');


    useEffect(() => {
        setData([...mainData]);
        setData2([...mainData]);
    }, [mainData]);

    const updateAfterTable = (item) => {
        let tmp = data;
        const index = data.findIndex(x => x.id === item.id);
        index !== -1 ? tmp[index] = item : tmp.push({ ...item, id: Number(data[data.length - 1].id) + 1 })
        setData([...tmp]);
        setData2([...tmp]);
    }

    const addAfterTable = (announcement) => {
        let tmp = data;
        tmp.unshift(announcement);
        setData([...tmp]);
        setData2([...tmp]);
    }

    const handleRequestSort = (event, property) => {
        const tempOrderBy = property;
        let tempOrder = 'desc';

        if (orderBy === property && order === 'desc') {
            tempOrder = 'asc';
        }
        const tempdata =
            tempOrder === 'desc'
                ? data.sort((a, b) => (b[tempOrderBy] < a[tempOrderBy] ? -1 : 1))
                : data.sort((a, b) => (a[tempOrderBy] < b[tempOrderBy] ? -1 : 1));

        setData(tempdata);
        setOrder(tempOrder);
        setOrderBy(tempOrderBy);
    };

    const DataTableHead = ({ onRequestSort, customColumnData }) => {
        const createSortHandler = property => event => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <TableRow>
                    {customColumnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                align={column.numeric}
                                padding={column.disablePadding ? 'none' : 'normal'}
                                sx={{ whiteSpace: 'normal' }}
                            >
                                <Tooltip
                                    title="Sırala"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={createSortHandler(column.id)}
                                        sx={{ whiteSpace: 'normal', '& .MuiTableSortLabel-icon': { flexShrink: 0 } }}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    };

    const updateAnnouncementInfo = (announcement) => {
        setSelectedAnnouncement(announcement)
        setUpdateInfoDialogStatus(true)
    }

    const showAnnouncementDetail = (announcement) => {
        setSelectedDetailAnnouncement(announcement)
        setDetailDialogStatus(true)
    }

    const deleteItem = (item) => {
        Swal.fire({
            title: 'Silme İşlemi',
            text: "'" + item.title + "' başlıklı duyuruyu silmek istediğinizden emin misiniz?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet Sil',
            cancelButtonText: "Vazgeç"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const result = await deleteObjectApi(ANNOUNCEMENT, item.id);
                setData([...data.filter(x => x.id !== item.id)])
                setData2([...data2.filter(x => x.id !== item.id)])
                if (result.status) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'İşlem başarılı.',
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            }
        })
    }

    const { baseFontSize, lineHeight, iconFontSize, fabStyle } = useTemplateFontSettings();

    return (
        <Paper className="col-md-12" sx={{ minWidth: 0, overflow: 'hidden' }}>
            <AnnouncementDataTableToolbar
                pageTitle={pageTitle}
                data2={data2}
                setData={setData}
                afterUpdateFunc={updateAfterTable}
                addAfterTable={addAfterTable}
                setHighlightQuery={setHighlightQuery}
            />

            <div className="flex-auto" style={{ minWidth: 0 }}>
                <Box sx={{ overflowX: 'auto' }}>
                    <Table
                        className=""
                        size='small'
                        sx={{
                            minWidth: 960,
                            '& .MuiTableCell-head': { whiteSpace: 'normal' },
                            '& .MuiTableSortLabel-root': { whiteSpace: 'normal' },
                            '& .MuiTableSortLabel-icon': { flexShrink: 0 },
                        }}
                    >
                        <DataTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={data.length}
                            customColumnData={column}
                        />
                        <TableBody>
                            {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                const user = userList.find(x => x.id === n.userId);
                                return (


                                    <TableRow hover key={"trO" + n.id}>

                                        <TableCell align="left" padding="normal" style={{ fontSize: baseFontSize, lineHeight: lineHeight }}>
                                            <Box display="flex" alignItems="center" gap={1}>

                                                <Avatar
                                                    alt=""
                                                    src={(user && user.profileImageUrl) ? config.userAuthApiUrl + user.profileImageUrl : config.userAuthApiUrl + config.defaultProfileImageUrl}
                                                    onError={(e) => { e.target.onerror = null; e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl }}
                                                    style={{ ...fabStyle }}

                                                />

                                                <span>{highlightText(getUserFullName(user), highlightQuery)}</span>
                                            </Box>
                                        </TableCell>

                                        <TableCell align="left" padding="normal" style={{ fontSize: baseFontSize, lineHeight: lineHeight }}>
                                            {n.toAnnouncement}
                                        </TableCell>

                                        <TableCell align="left" padding="normal" style={{ fontSize: baseFontSize, lineHeight: lineHeight }}>
                                            {highlightText(n.title, highlightQuery)}
                                        </TableCell>

                                        <TableCell align="left" padding="normal" style={{ fontSize: baseFontSize, lineHeight: lineHeight }}>
                                            <Chip
                                                label={n.status === 1 ? "Açık" : "Kapalı"}
                                                color={n.status === 1 ? "success" : "error"}
                                                size="small"
                                            />
                                        </TableCell>

                                        <TableCell align="left" padding="normal" style={{ fontSize: baseFontSize, lineHeight: lineHeight }}>
                                            {getLocaleDateWithTimeCustomV2("tr", n.updatedDate)}
                                        </TableCell>
                                        <TableCell align="left" padding="none">
                                            {isRoleCheckList(authUser.userRoles, [1, 373, 370]) && (
                                                <>
                                                    <Tooltip style={{ width: 'auto' }} title="Duyuru Güncelle">
                                                        <Button style={{ minWidth: '40px', fontSize: iconFontSize }} key="one" onClick={() => updateAnnouncementInfo(n)}>
                                                            <UpdateIcon color='info' fontSize='small' />
                                                        </Button>
                                                    </Tooltip>
                                                    <Tooltip title="Duyuru Sil" >
                                                        <Button style={{ minWidth: '40px', fontSize: iconFontSize }} key="two" onClick={() => deleteItem(n)} >
                                                            <DeleteIcon color='error' fontSize='small' />
                                                        </Button>
                                                    </Tooltip>
                                                </>
                                            )}

                                            {isRoleCheckList(authUser.userRoles, [1, 373, 370, 369, 372]) && (
                                                <>
                                                    <Tooltip style={{ width: 'auto' }} title="Detay">
                                                        <Button style={{ minWidth: '40px', fontSize: iconFontSize }} key="three" onClick={() => showAnnouncementDetail(n)}>
                                                            <VisibilityIcon color='primary' fontSize='small' />
                                                        </Button>
                                                    </Tooltip>
                                                </>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    count={data.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={(e, page) => setPage(page)}
                                    onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                                    labelRowsPerPage={"Görüntülenecek Satır"}
                                    rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                                    showFirstButton
                                    showLastButton
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Box>
            </div>

            <AddUpdateAnnouncementDialog
                open={updateInfoDialogStatus}
                onClose={() => setUpdateInfoDialogStatus(false)}
                afterUpdateFunc={updateAfterTable}
                addAfterTable={addAfterTable}
                selectedAnnouncement={selectedAnnouncement}
            />

            {selectedDetailAnnouncement && (
                <AnnouncementItemDialog
                    open={detailDialogStatus}
                    onClose={() => setDetailDialogStatus(false)}
                    announcement={selectedDetailAnnouncement}
                />
            )}
        </Paper>
    )
}

export default AnnouncementDataTable